export function photoReturn(search:string,fallback:'/work-photos'|'/community/photos'){
 const base={path:fallback==='/work-photos'?'/projects':fallback,label:fallback==='/work-photos'?'Back to projects':'Nature Gallery',context:undefined as undefined|{type:'project'|'asset';id:string}};
 const raw=new URLSearchParams(search).get('returnTo');
 if(!raw||!raw.startsWith('/')||raw.startsWith('//')||/[\\\u0000-\u001f]/.test(raw)||/%(?:2f|5c)/i.test(raw))return base;
 try{
  const url=new URL(raw,'https://photo.local');
  if(url.origin!=='https://photo.local'||url.hash)return base;
  const match=/^\/(projects|assets)\/([^/]+)$/.exec(url.pathname);
  if(match)return {path:url.pathname,label:match[1]==='projects'?'Back to project':'Back to asset',context:{type:match[1]==='projects'?'project' as const:'asset' as const,id:decodeURIComponent(match[2])}};
  if(url.pathname==='/')return {...base,path:'/',label:'Back to the map'};
  if(url.pathname==='/map-features'){
   const place=url.searchParams.get('place');
   return {...base,path:'/map-features'+(place?'?'+new URLSearchParams({place}).toString():''),label:'Back to place'};
  }
  if(url.pathname==='/settings/photos')return {...base,path:url.pathname,label:'Back to photo review'};
 }catch{/* Untrusted return paths fall back to the collection. */}
 return base;
}
